<template>
  <div v-if="showBareLayout">
    <router-view style="border-radius: 4px"></router-view>
  </div>
  <div class="home" v-else>
    <el-container class="home-container">
      <el-container>
        <!-- 左侧边栏 -->
        <div @mouseenter="closeMenu">
          <el-aside
            class="leftMain"
            :class="[{ isActive: isCollapse === true }]"
            v-if="!inQlw"
          >
            <el-aside
              class="left1"
              ref="asideLeft"
              :class="[{ isActive: isCollapse === true }]"
            >
              <!-- 左侧图标 -->
              <div class="left-logo">
                <router-link to="/">
                  <img
                    v-if="!isCollapse"
                    :src="logoImg"
                    :class="{ 'yinbao-logo-img': isYinbaoEnterprise }"
                    alt=""
                  />
                  <img
                    v-else
                    :src="logoSmallImg"
                    :class="{ 'yinbao-logo-img': isYinbaoEnterprise }"
                    alt=""
                  />
                </router-link>
              </div>
              <!-- default-active="0" 默认开启几个-->
            </el-aside>
            <el-aside
              class="left"
              ref="asideLeft"
              :class="[{ isActive: isCollapse === true }]"
            >
              <!-- default-active="0" 默认开启几个-->
              <div>
                <el-menu
                  class="el-menu-vertical-demo"
                  :default-active="getRoute"
                  @open="handleOpen"
                  @close="handleClose"
                  :collapse="isCollapse"
                  collapse-transition
                  :router="true"
                  :unique-opened="true"
                >
                  <!-- 判断是否有子元素，无则显示默认图片 -->
                  <div v-for="(item, index) in leftList" :key="index">
                    <!-- 层级为第一层 没有子元素-->
                    <el-menu-item
                      :index="item.path"
                      v-if="!item.child && item.show"
                    >
                      <!-- <i class="el-icon-menu"></i> -->
                      <img style="margin-right: 8px" :src="item.img" alt="" />
                      <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                    <!-- 有子元素 -->
                    <el-submenu
                      :index="index + ''"
                      v-if="item.child && level1(item)"
                    >
                      <template slot="title">
                        <!-- <i class="el-icon-menu"></i> -->
                        <img style="margin-right: 8px" :src="item.img" alt="" />
                        <span slot="title">{{ item.name }}</span>
                      </template>
                      <div v-for="(item2, index2) in item.child" :key="index2">
                        <!-- 层级为第二层 有子元素-->
                        <el-submenu
                          v-if="item2.child && level2(item2)"
                          :index="index + '-' + index2"
                        >
                          <template slot="title">
                            <img
                              style="margin-right: 8px"
                              :src="item2.img"
                              alt=""
                            />
                            <span
                              slot="title"
                              style="color: #565656; font-size: 15px"
                              >{{ item2.name }}</span
                            >
                          </template>
                          <!-- 层级为第三层 -->
                          <div
                            v-for="(item3, index3) in item2.child"
                            :key="index3"
                          >
                            <el-menu-item :index="item3.path" v-if="item3.show">
                              <span slot="title" style="padding-left: 9px">{{
                                item3.name
                              }}</span>
                            </el-menu-item>
                          </div>
                        </el-submenu>
                        <!-- 层级为第二层 无子元素-->
                        <el-menu-item
                          :index="item2.path"
                          v-if="!item2.child && item2.show"
                          @click="onMenuItemClick(item2.name)"
                        >
                          <img
                            style="margin-right: 8px"
                            :src="item2.img"
                            alt=""
                          />
                          <span slot="title" style="margin-right: 10px">{{
                            item2.name
                          }}</span>
                        </el-menu-item>
                      </div>
                    </el-submenu>
                  </div>
                </el-menu>
              </div>
            </el-aside>
          </el-aside>
        </div>
        <!-- 主要区域容器 -->
        <el-container>
          <!-- 头部区域 -->
          <el-header class="main-header" v-if="!inQlw">
            <div class="main-header-logo">
              <div class="main-header-1">
                <div class="main-header-logo-one">
                  <img
                    src="../../public/img/icon_list_closed.png"
                    @click="goCollapse"
                    alt=""
                  />
                  &nbsp; &nbsp;
                  <!-- <span style=" font-size:16px;color:#2189ff;cursor: pointer;" @click="intoOldVersion">返回旧版渔管理</span> -->
                </div>
                <div class="yearChange" v-if="$route.name === 'home'">
                  <span>年份选择：&nbsp;</span>
                  <el-select
                    filterable
                    placeholder="请选择"
                    size="small"
                    v-model="year"
                    style=""
                    @change="changeYear"
                  >
                    <el-option
                      v-for="(item, index) in yearList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="main-header-logo-two">
                <!-- 天气定制样式  http://www.tianqi.com/dingzhi/ -->
                <iframe
                  name="weather_inc"
                  style="
                    position: absolute;
                    margin-left: -265px;
                    margin-top: 15px;
                  "
                  src="http://i.tianqi.com/index.php?c=code&id=10"
                  width="280"
                  height="25"
                  frameborder="0"
                  marginwidth="0"
                  marginheight="0"
                  scrolling="no"
                ></iframe>
              </div>
            </div>
            <div class="main-header-box">
              <ul class="main-header-box-one">
                <li @click="use()">应用中心</li>
                <li @click="newHome()">新首页入口</li>
                <li @click="help()">帮助中心</li>
                <!-- <li class="li">手机智农通<img src="../../public/img/zhinengtong.png" alt="">
                </li> -->
              </ul>

              <div class="main-header-box-two">
                <img
                  v-if="loginUser.photoUrl"
                  :src="getImgUrl(loginUser.photoUrl)"
                  alt=""
                />
                <img v-else src="../../public/img/user_img.png" alt="" />
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    {{ loginUser.nickName
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="personCenter()"
                      >个人中心</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="companyAuth()"
                      >企业认证</el-dropdown-item
                    >
                    <!-- <el-dropdown-item @click.native="qualityTracing()">质量追溯</el-dropdown-item> -->
                    <!-- <el-dropdown-item>大数据平台</el-dropdown-item> -->
                    <el-dropdown-item @click.native="logout"
                      >退出登录</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <!-- <span style="color:#3389ff;margin-right:20px;">{{this.companyName}}</span> -->
              <el-select
                placeholder="请选择"
                size="small"
                @change="onCompanySelect"
                v-model="companyName"
                class="selectCompany"
              >
                <template v-for="item in enterprises">
                  <el-option
                    v-if="
                      !isOwner ||
                      (isOwner && item.enterpriseName !== '创建渔场')
                    "
                    :key="item.enterpriseId"
                    :label="item.enterpriseName"
                    :value="item.enterpriseId"
                  >
                  </el-option>
                </template>
              </el-select>
            </div>
          </el-header>
          <div style="height: 32px; background: #fff; padding-bottom: 2px">
            <tags-view></tags-view>
          </div>
          <el-main class="main">
            <keep-alive
              :include="[
                'fryPurchase',
                'fishSales',
                'feedPurchase',
                'drugProcurement',
                'manureProcurement',
                'lossManagement',
                'turnPondManagement',
                'proofingManagement',
                'feedingManagement',
                'manureManagement',
                'preventionManagement',
              ]"
              ><!--缓存组件：苗种采购、成鱼销售、饲料采购、药品采购、鱼肥采购、损耗管理、转塘管理、打样管理、投喂管理、鱼肥管理、防疫防治-->
              <router-view style="border-radius: 4px"></router-view>
            </keep-alive>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <iframe :src="loginout" hidden></iframe>
  </div>
</template>

<script>
import api from "../service/api.js";
import url from "../service/base-url";
import { mapActions, mapState, mapGetters } from "vuex";
import { modules, store } from "../store";
import checkPermission from "../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import TagsView from "@/components/TagsView";
import { isYinbaoLogoByFlag, YINBAO_LOGO } from "@/common/yinbaoEnterprise.js";
import { isLeaseMenuVisibleByEnterpriseType } from "@/service/fishPondLeaseEnums.js";

export default {
  name: "home",
  mixins: [mixins],
  components: { TagsView },
  data() {
    return {
      baseList: [],
      year: new Date().getFullYear(),
      yearList: [
        {
          id: 1,
          name: 2017,
        },
        {
          id: 2,
          name: 2018,
        },
        {
          id: 3,
          name: 2019,
        },
        {
          id: 4,
          name: 2020,
        },
        {
          id: 5,
          name: 2021,
        },
        {
          id: 6,
          name: 2022,
        },
        {
          id: 7,
          name: 2023,
        },
        {
          id: 8,
          name: 2024,
        },
        {
          id: 9,
          name: 2025,
        },
        {
          id: 10,
          name: 2026,
        },
        {
          id: 11,
          name: 2027,
        },
        {
          id: 8,
          name: 2028,
        },
      ],
      leftList: [
        {
          name: "基础设置",
          permissionId: 100,
          img: require("../assets/img/first/icon_set.png"),
          show: false,
          child: [
            // {
            //   name: "公司管理",
            //   permissionId: 200,
            //   img: "/img/second/icon_gongsiguanli.png",
            //   show: false,
            //   child: [
            //     // {
            //     //   name: "单位信息",
            //     //   path: "/setting/companyManagement/unitInformation"
            //     // },
            //     {
            //       name: "基地设置",
            //       permissionId: 500,
            //       show: false,
            //       path: "/setting/companyManagement/baseSetting"
            //     },
            //     {
            //       name: "塘口设置",
            //       permissionId: 501,
            //       show: false,
            //       path: "/setting/companyManagement/pondSetting"
            //     },
            //     {
            //       name: "养殖品种设置",
            //       permissionId: 502,
            //       show: false,
            //       path: "/setting/companyManagement/cultureBreed"
            //     },
            //     {
            //       name: "公司设置",
            //       permissionId: 503,
            //       show: false,
            //       path: "/setting/companyManagement/companySetting"
            //     }
            //   ]
            // },
            {
              name: "公司设置",
              permissionId: 503,
              show: false,
              path: "/setting/companySetting",
              img: require("../assets/img/second/icon_gongsiguanli.png"),
            },
            {
              name: "基地设置",
              permissionId: 500,
              show: false,
              path: "/setting/baseSetting",
              img: require("../assets/img/second/icon_jidishezhi.png"),
            },
            {
              name: "塘口设置",
              permissionId: 501,
              show: false,
              path: "/setting/pondSetting",
              img: require("../assets/img/second/icon_tangkoushezhi.png"),
            },
            {
              name: "养殖品种设置",
              permissionId: 502,
              show: false,
              path: "/setting/cultureBreed",
              img: require("../assets/img/second/icon_yangzhipinzhongshezhi.png"),
            },
            {
              name: "种植品种设置",
              permissionId: 502,
              show: false,
              path: "/setting/plantSpecies",
              img: require("../assets/img/second/icon_yangzhipinzhongshezhi.png"),
            },
            {
              name: "用户管理",
              permissionId: 201,
              show: false,
              path: "/setting/PersonManagement",
              img: require("../assets/img/second/icon_renyuanquanxianguanli.png"),
            },
            // {
            //   name: "商品设置",
            //   img: "/img/second/icon_shangpinshezhi.png",
            //   child: [
            //     {
            //       name: "商品代号",
            //       path: "/setting/goodsSetting/goodsCode"
            //     },
            //     {
            //       name: "商品代号分类",
            //       path: "/setting/goodsSetting/goodsCodeClassify"
            //     },
            //     {
            //       name: "商品名称",
            //       path: "/setting/goodsSetting/goodsName"
            //     },
            //     {
            //       name: "商品品牌",
            //       path: "/setting/goodsSetting/goodsBrand"
            //     },
            //     {
            //       name: "商品分类",
            //       path: "/setting/goodsSetting/goodsCategory"
            //     }
            //   ]
            // },
            // {
            //   name: "人员权限管理",
            //   img: "/img/second/icon_renyuanquanxianguanli.png",
            //   child: [
            //     {
            //       name: "角色设置",
            //       path: "/setting/personalAuthorityManagement/roleSetting"
            //     },
            //     {
            //       name: "公司人员管理",
            //       path: "/setting/personalAuthorityManagement/companyManagement"
            //     },
            //     {
            //       name: "员工权限",
            //       path:
            //         "/setting/personalAuthorityManagement/personnelAuthority"
            //     },
            //     {
            //       name: "权限分配",
            //       path:
            //         "/setting/personalAuthorityManagement/permissionAssignment"
            //     }
            //   ]
            // },
            {
              name: "购销单位",
              permissionId: 202,
              show: false,
              path: "/setting/purchaseUnit",
              img: require("../assets/img/second/icon_gouxiaodanwei.png"),
            },
            {
              name: "物资设置",
              permissionId: 203,
              show: false,
              path: "/setting/materialSetting",
              img: require("../assets/img/second/icon_wuzishezhi.png"),
            },
            {
              name: "平板设备管理",
              permissionId: 208,
              show: false,
              img: require("../assets/img/second/icon_shebeishezhi.png"),
              path: "/setting/deviceManage",
            },

            // {
            //   name: "客户档案",
            //   img: "/img/second/icon_kehudangan.png",
            //   child: [
            //     {
            //       name: "供应商档案",
            //       path: "/setting/supplierManagement/supplierProfile"
            //     },
            //     {
            //       name: "客户档案",
            //       path: "/setting/supplierManagement/customerProfile"
            //     }
            //   ]
            // }
          ],
        },
        // {
        //   name: "智能设备",
        //   permissionId: 101,
        //   show: false,
        //   img: "/img/first/icon_zhinengshebei.png",
        //   path: "/smartDevice",
        //   icon: "el-icon-setting"
        // },
        {
          name: "智能设备",
          permissionId: 101,
          show: false,
          img: require("../assets/img/first/icon_zhinengshebei.png"),
          child: [
            {
              name: "设备管理",
              permissionId: 208,
              show: false,
              img: require("../assets/img/second/icon_shebeishezhi.png"),
              path: "/smartDevice/deviceManage",
            },
            {
              name: "报警管理",
              permissionId: 212,
              show: false,
              img: require("../assets/img/second/icon_baojingguanli.png"),
              path: "/smartDevice/alarmManage",
            },
            {
              name: "水质监测",
              permissionId: 209,
              show: false,
              img: require("../assets/img/second/icon_shuizhijiance.png"),
              path: "/smartDevice/waterMonitorIndex",
            },
            {
              name: "尾水监测",
              permissionId: 209,
              show: false,
              img: require("../assets/img/second/icon_shuizhijiance.png"),
              path: "/tailWaterMonitoring",
            },
            {
              name: "地图定位",
              permissionId: 210,
              show: false,
              img: require("../assets/img/second/icon_ditudingwei.png"),
              path: "/smartDevice/mapLocaltion",
            },
            {
              name: "视频监控",
              permissionId: 211,
              show: false,
              img: require("../assets/img/second/icon_shipinjiankong.png"),
              path: "/smartDevice/videoMonitor",
            },
          ],
          // img: require("../assets/img/first/icon_zhinengshebei.png"),
          // path: "/smartDevice",
          // icon: "el-icon-setting"
        },

        {
          name: "购销管理",
          permissionId: 102,
          show: false,
          img: require("../assets/img/first/icon_gouxiaoguanli.png"),
          child: [
            {
              name: "苗种采购",
              permissionId: 214,
              show: false,
              img: require("../assets/img/second/icon_miaozhongcaigou.png"),
              path: "/buyingAndSelling/fryPurchase",
            },
            {
              name: "成鱼销售",
              permissionId: 215,
              show: false,
              img: require("../assets/img/second/icon_chengyuxiaoshou.png"),
              path: "/buyingAndSelling/fishSales",
            },
            // {
            //   name: "物资采购",
            //   permissionId: 216,
            //   show: false,
            //   img: require("../assets/img/second/icon_wuzicaigou.png"),
            //   path: "/buyingAndSelling/materialPurchase"
            // },
            {
              name: "饲料采购",
              permissionId: 216,
              show: false,
              img: require("../assets/img/second/icon_wuzicaigou.png"),
              path: "/buyingAndSelling/feedPurchase",
            },
            {
              name: "药品采购",
              permissionId: 216,
              show: false,
              img: require("../assets/img/second/icon_wuzicaigou.png"),
              path: "/buyingAndSelling/drugProcurement",
            },
            {
              name: "渔肥采购",
              permissionId: 216,
              show: false,
              img: require("../assets/img/second/icon_wuzicaigou.png"),
              path: "/buyingAndSelling/manureProcurement",
            },
          ],
        },
        {
          name: "生产管理",
          permissionId: 104,
          show: false,
          img: require("../assets/img/first/icon_shengchanguanli.png"),
          child: [
            {
              name: "生产计划",
              permissionId: 225,
              show: false,
              img: require("../assets/img/second/icon_shengchanjihua.png"),
              path: "/productionControl/productionPlan",
            },
            {
              name: "养殖周期管理",
              permissionId: 226,
              show: false,
              img: require("../assets/img/second/icon_yangzhizhouqiguanli.png"),
              path: "/productionControl/cultureCycle",
            },
            {
              name: "损耗管理",
              permissionId: 227,
              show: false,
              img: require("../assets/img/second/icon_sunhaoguanli.png"),
              path: "/productionControl/lossManagement",
            },
            {
              name: "转塘管理",
              permissionId: 228,
              show: false,
              img: require("../assets/img/second/icon_zhuantangguanli.png"),
              path: "/productionControl/turnPondManagement",
            },
            {
              name: "打样管理",
              permissionId: 229,
              show: false,
              img: require("../assets/img/second/icon_dayangguanli.png"),
              path: "/productionControl/proofingManagement",
            },
            {
              name: "投喂管理",
              permissionId: 235,
              show: false,
              img: require("../assets/img/second/icon_touweiguanli.png"),
              path: "/productionControl/feedingManagement",
            },
            {
              name: "投喂管理明细",
              permissionId: 235,
              show: false,
              img: require("../assets/img/second/icon_touweiguanli.png"),
              path: "/productionControl/feedingManagement/feedingDetail",
            },
            {
              name: "渔肥管理",
              permissionId: 235,
              show: false,
              img: require("../assets/img/second/icon_touweiguanli.png"),
              path: "/productionControl/manureManagement",
            },
            {
              name: "防疫防治",
              permissionId: 236,
              show: false,
              img: require("../assets/img/second/icon_fangyifangzhi.png"),
              path: "/productionControl/preventionManagement",
            },
            {
              name: "水质参数",
              permissionId: 230,
              show: false,
              img: require("../assets/img/second/icon_shuizhicanshu.png"),
              child: [
                {
                  name: "水质参数录入",
                  permissionId: 515,
                  show: false,
                  path: "/productionControl/waterQualityParameters/parameterInput",
                },
                {
                  name: "水质参数曲线图",
                  permissionId: 516,
                  show: false,
                  path: "/productionControl/waterQualityParameters/parameterLine",
                },
              ],
            },
          ],
        },
        {
          name: "成本管理",
          permissionId: 103,
          show: false,
          img: require("../assets/img/first/icon_feiyongguanli.png"),
          child: [
            {
              name: "资产原值",
              permissionId: 218,
              show: false,
              img: require("../assets/img/second/icon_zichanyuanzhi.png"),
              path: "/expense/costOriginValue",
            },
            {
              name: "资产计提",
              permissionId: 219,
              show: false,
              img: require("../assets/img/second/icon_zichanjiti.png"),
              path: "/expense/assetsCalculation",
            },
            {
              name: "费用支出",
              permissionId: 220,
              show: false,
              img: require("../assets/img/second/icon_feiyongjilu.png"),
              path: "/expense/expenseRecord",
            },
            {
              name: "费用收入",
              permissionId: 220,
              show: false,
              img: require("../assets/img/second/icon_feiyongjilu.png"),
              path: "/expense/feeIncome",
            },
            {
              name: "费用分摊汇总表",
              permissionId: 222,
              show: false,
              img: require("../assets/img/second/icon_feiyongfentanhuizongbiao.png"),
              path: "/expense/costSummaryTable",
            },
            {
              name: "费用设置",
              permissionId: 221,
              show: false,
              img: require("../assets/img/second/icon_feiyongshezhi.png"),
              path: "/expense/expenseSetting",
            },
          ],
        },

        // {
        //   name: "物资管理",
        //   img: "/img/first/icon_wuziguanli.png",
        //   child: [
        //     {
        //       name: "投喂管理",
        //       img: "/img/second/icon_touweiguanli.png",
        //       path: "/goodsManagement/feedingManagement"
        //     },
        //     {
        //       name: "防疫防治",
        //       img: "/img/second/icon_fangyifangzhi.png",
        //       path: "/goodsManagement/preventionManagement"
        //     }
        //   ]
        // },
        // 暂时隐藏
        // {
        //   name: "质量追溯",
        //   img: "/img/first/icon_zhiliangzhuisu.png",
        //   path: "/qualityTracking",
        //   icon: "el-icon-setting"
        // },
        // {
        //   name: "大数据运行平台",
        //   img: "/img/first/icon_dashujuyunxing.png",
        //   path: "/bigDataPlatform",
        //   icon: "el-icon-setting"
        // },
        {
          name: "数据分析",
          permissionId: 106,
          show: false,
          img: require("../assets/img/first/icon_shujufenxi.png"),
          child: [
            {
              name: "生产报表",
              permissionId: 243,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "/dataAnalyze/productionReport",
            },
            // {
            //   name: "预估产出表",
            //   permissionId: 243,
            //   show: false,
            //   img: require("../assets/img/second/icon_shengchanbaobiao.png"),
            //   path: "/dataAnalyze/estimatedOutputReport"
            // },
            // {
            //   name: "生产利润表",
            //   permissionId: 243,
            //   show: false,
            //   img: require("../assets/img/second/icon_shengchanbaobiao.png"),
            //   path: "/dataAnalyze/productionProfitReport"
            // },
            {
              name: "生产利润表",
              permissionId: 243,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "",
              routeName: "productionProfitReport2",
            },
            {
              name: "鱼均费用报表",
              permissionId: 243,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "",
              routeName: "fishAvgCostReport2",
            },
            {
              name: "预估存塘报表",
              permissionId: 250,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "/dataAnalyze/storagePondReport",
            },
            {
              name: "出塘报表",
              permissionId: 244,
              show: false,
              img: require("../assets/img/second/icon_chutangbaobiao.png"),
              path: "/dataAnalyze/outPondReport",
            },
            {
              name: "损失报表",
              permissionId: 245,
              show: false,
              img: require("../assets/img/second/icon_sunshibaobiao.png"),
              path: "/dataAnalyze/lossReport",
            },
            {
              name: "物资耗用汇总表",
              permissionId: 246,
              show: false,
              img: require("../assets/img/second/icon_wuzihaoyong.png"),
              path: "/dataAnalyze/goodLossSummaryReport",
            },
            {
              name: "库存报表",
              permissionId: 247,
              show: false,
              img: require("../assets/img/second/icon_kucunbaobiao.png"),
              path: "/dataAnalyze/stockReport",
            },
            {
              name: "收支报表",
              permissionId: 248,
              show: false,
              img: require("../assets/img/second/icon_shouzhibaobiao.png"),
              path: "/dataAnalyze/inOutReport",
            },
            {
              name: "收支排行榜",
              permissionId: 249,
              show: false,
              img: require("../assets/img/second/icon_shouzhipaihangbang.png"),
              path: "/dataAnalyze/inOutRank",
            },
          ],
        },
        {
          name: "鱼塘租赁",
          permissionId: 108,
          show: false,
          img: require("../assets/img/first/icon_shengchanguanli.png"),
          child: [
            {
              name: "标的物管理",
              permissionId: 520,
              show: false,
              img: require("../assets/img/second/icon_tangkoushezhi.png"),
              path: "/fishPondLease/property",
            },
            {
              name: "标的物审核",
              permissionId: 521,
              show: false,
              img: require("../assets/img/second/icon_tangkoushezhi.png"),
              path: "/fishPondLease/propertyAudit",
            },
            {
              name: "承租方管理",
              permissionId: 522,
              show: false,
              img: require("../assets/img/second/icon_gongsiguanli.png"),
              path: "/fishPondLease/tenant",
            },
            {
              name: "承租方审核",
              permissionId: 523,
              show: false,
              img: require("../assets/img/second/icon_renyuanquanxianguanli.png"),
              path: "/fishPondLease/tenantAudit",
            },
            {
              name: "合同管理",
              permissionId: 524,
              show: false,
              img: require("../assets/img/second/icon_shengchanjihua.png"),
              path: "/fishPondLease/contract",
            },
            {
              name: "租金管理",
              permissionId: 525,
              show: false,
              img: require("../assets/img/second/icon_shouzhibaobiao.png"),
              path: "/fishPondLease/rent",
            },
            {
              name: "鱼塘汇总",
              permissionId: 527,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "/fishPondLease/stat",
            },
            {
              name: "标的物配置",
              permissionId: 528,
              show: false,
              img: require("../assets/img/second/icon_wuzihaoyong.png"),
              path: "/fishPondLease/config",
            },
            {
              name: "合同模板管理",
              permissionId: 526,
              show: false,
              img: require("../assets/img/second/icon_shengchanbaobiao.png"),
              path: "/fishPondLease/contractTemplate",
            },
          ],
        },
        {
          name: "质量追溯",
          permissionId: 107,
          show: false,
          img: require("../assets/img/first/icon_zhiliangzhuisu.png"),
          path: "/backEnd",
          icon: "el-icon-setting",
        },
        {
          name: "企业大数据平台",
          permissionId: 105,
          show: false,
          img: require("../assets/img/first/icon_qiyedashuju.png"),
          path: "/enterpriseBigData",
          icon: "el-icon-setting",
        },
      ],
      specialLeftList: [
        {
          name: "基础设置",
          permissionId: 100,
          img: require("../assets/img/first/icon_set.png"),
          show: false,
          child: [
            {
              name: "公司设置",
              permissionId: 503,
              show: false,
              path: "/setting/companySetting",
              img: require("../assets/img/second/icon_gongsiguanli.png"),
            },
            {
              name: "基地设置",
              permissionId: 500,
              show: false,
              path: "/setting/baseSetting",
              img: require("../assets/img/second/icon_jidishezhi.png"),
            },
            {
              name: "塘口设置",
              permissionId: 501,
              show: false,
              path: "/setting/pondSetting",
              img: require("../assets/img/second/icon_tangkoushezhi.png"),
            },
            {
              name: "用户管理",
              permissionId: 201,
              show: false,
              path: "/setting/PersonManagement",
              img: require("../assets/img/second/icon_renyuanquanxianguanli.png"),
            },
          ],
        },
        {
          name: "智能设备",
          permissionId: 101,
          show: false,
          img: require("../assets/img/first/icon_zhinengshebei.png"),
          child: [
            {
              name: "设备管理",
              permissionId: 208,
              show: false,
              img: require("../assets/img/second/icon_shebeishezhi.png"),
              path: "/smartDevice/deviceManage",
            },
            {
              name: "报警管理",
              permissionId: 212,
              show: false,
              img: require("../assets/img/second/icon_baojingguanli.png"),
              path: "/smartDevice/alarmManage",
            },
            {
              name: "尾水监测",
              permissionId: 209,
              show: false,
              img: require("../assets/img/second/icon_shuizhijiance.png"),
              path: "/tailWaterMonitoring",
            },
            {
              name: "地图定位",
              permissionId: 210,
              show: false,
              img: require("../assets/img/second/icon_ditudingwei.png"),
              path: "/smartDevice/mapLocaltion",
            },
            {
              name: "视频监控",
              permissionId: 211,
              show: false,
              img: require("../assets/img/second/icon_shipinjiankong.png"),
              path: "/smartDevice/videoMonitor",
            },
          ],
        },
      ],
      leftIndex: null,
      isCollapse: false,
      companyName: "",
      enterprisesList: [],
      loginout: "",
      cachedViews: this.$store.state.cachedViews,
      isOwner: "",
    };
  },
  watch: {
    // enterprises() {
    //   this.companyName = this.enterprises.enterpriseName;
    // },
    // 监听isQlwVersion
    whetherQlw(val) {
      this.leftside();
    },
    $route() {
      this.cachedViews = this.$store.state.cachedViews;
    },
  },
  methods: {
    ...mapActions(["getCurCompany"]),
    ...mapActions(modules.account, ["getUserCompany"]),
    ...mapActions(modules.user, {
      getYanShiFishery: "getYanShiFishery",
    }),
    // 切换年份--首页报表
    changeYear(val) {
      this.year = val;
      localStorage.setItem("homePageYearVal", this.year);
      localStorage.setItem("homeYearIndex", this.year);
      this.bus.$emit("getYear", val);
    },
    //切换到旧版渔管理
    intoOldVersion() {
      window.open("http://ylwgl2.nxin.com/Main");
    },
    //获取切换公司-公司列表
    async getCompanys() {
      await this.getUserCompany();
      this.companyName = this.enterprises.find(
        (f) => f.selected == true
      ).enterpriseId;
    },
    async onCompanySelect(id) {
      if (id == -2) {
        this.$router.push({
          name: "CreateFishery",
        });
      } else {
        const company = (this.enterprises || []).find(
          (f) => f.enterpriseId == id
        );
        // 先进入顶层过渡页，卸掉旧侧栏，避免切换未完成时误点旧公司菜单
        this.$router.replace({
          name: "switchingCompany",
          query: {
            id: String(id),
            name: company ? company.enterpriseName : "",
          },
        });
      }
    },
    //侧边栏显示
    async leftside() {
      //非企联网版本
      if (
        this.curCompany.isQlwVersion == false ||
        this.curCompany.isQlwVersion == null
      ) {
        if (this.loginUser.permissions != null) {
          // 检查是否 有权限显示
          this.checkShow(this.loginUser.permissions, this.leftList);
          this.applyFishPondLeaseMenuByEnterpriseType(this.leftList);
          let leftList = this.fildata(this.leftList);
          this.leftList = leftList;
        }
      } else {
        //企联网版本
        const permissions = await checkPermission.getQlwPermissions();
        this.isQlwPermission(this.leftList, permissions);
        this.applyFishPondLeaseMenuByEnterpriseType(this.leftList);
        this.leftList = this.leftList;
      }
    },
    /**
     * 鱼塘租赁菜单：权限 + 企业类型双重过滤（对齐源系统 companyLevel）
     * 二级(2)：审核 + 合同/租金查看 + 鱼塘汇总 + 标的物配置 + 合同模板管理
     * 三级(3)：管理 + 合同/租金 + 统计
     * 普通/承租方：不展示租赁业务菜单
     */
    applyFishPondLeaseMenuByEnterpriseType(list) {
      if (!list || !list.length) return;
      const enterpriseType = Number(
        this.curCompany && this.curCompany.enterpriseType
      );
      const walk = items => {
        items.forEach(item => {
          if (item.permissionId === 108 && item.child) {
            item.child.forEach(child => {
              if (
                child.permissionId >= 520 &&
                child.permissionId <= 528
              ) {
                child.show =
                  !!child.show &&
                  isLeaseMenuVisibleByEnterpriseType(
                    enterpriseType,
                    child.permissionId
                  );
              }
            });
            item.show = item.child.some(c => c.show);
          } else if (item.child) {
            walk(item.child);
          }
        });
      };
      walk(list);
    },
    getImgUrl(name) {
      // 拼接url
      if (!name) {
        return "";
      } else {
        return url.nxinFileUrl + name;
      }
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    goCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async login() {
      await api.get(`${url.base}/api/account/checkauth`);
    },
    //退出
    async logout() {
      try {
        this.loginout = `${url.base}/api/account/logout`;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    },
    qualityTracing() {
      window.open(url.quantityUrl + "/backEnd");
    },
    //个人中心
    personCenter() {
      window.open(url.editInfo);
    },
    // 企业认证
    companyAuth() {
      window.open(url.entInfo);
    },
    //应用中心
    use() {
      window.open(url.oaUrl + "/store/index");
    },
    checkShow(array, list) {
      array.forEach((element) => {
        this.getData(list, element);
      });
    },
    // 递归获取
    getData(list, element) {
      list.forEach((item) => {
        if (item.permissionId == element.permissionId) {
          item.show = true;
        }
        if (item.child) {
          this.getData(item.child, element);
        }
      });
    },
    fildata(arr) {
      // let len = arr.length;
      // for (let i = 0; i < len; i++) {
      //   if (arr[i].show == false && !arr[i].child) {
      //     console.log(arr[i].name);
      //     arr.splice(i, 1);
      //   }
      //   if (arr[i].child) {
      //     this.fildata(arr[i].child);
      //   }
      // }
      let filterdata = arr.filter((item) => {
        if (item.child) {
          this.fildata(item.child);
        }
        return item.show == true || item.child;
      });
      return filterdata;
    },
    getRouteMenuIdByPath(path) {
      if (!path) {
        return undefined;
      }
      const resolved = this.$router.resolve(path).route;
      const matched = resolved.matched.filter(
        (item) => item.meta && item.meta.menuId !== undefined
      );
      const route = matched[matched.length - 1];
      return route && route.meta.menuId;
    },
    getQlwMenuId(item) {
      if (item.menuId !== undefined) {
        return item.menuId;
      }
      if (item.routeName) {
        return checkPermission.getMenuId(this.$router.resolve({ name: item.routeName }).route);
      }
      return this.getRouteMenuIdByPath(item.path);
    },
    hasQlwViewPermission(item, permissions) {
      const menuId = this.getQlwMenuId(item);
      const permission = checkPermission.getPermission(permissions, menuId);
      return Boolean(permission && (permission.permissionSumCode & 1) > 0);
    },
    // 企联网版本权限
    isQlwPermission(array, permissions) {
      array.forEach((item) => {
        if (item.child) {
          this.isQlwPermission(item.child, permissions);
          item.show = item.child.some((child) => child.show);
        } else {
          item.show = this.hasQlwViewPermission(item, permissions);
        }
      });
    },

    //帮助中心
    help() {
      window.open(url.helpUrl);
    },
    // 新首页
    newHome() {
      window.open("/farmMonitoring");
    },
    onMenuItemClick(name) {
      this.isCollapse = true;
      if (name === "生产利润表") {
        const routeData = this.$router.resolve({
          name: "productionProfitReport2",
        });
        window.open(routeData.href, "_blank");
      }else if (name === "鱼均费用报表") {
        const routeData = this.$router.resolve({
          name: "fishAvgCostReport2",
        });
        window.open(routeData.href, "_blank");
      }
      return;
      if (name === "尾水监测") {
        const routeData = this.$router.resolve({
          name: "tailWaterMonitoring",
        });
        window.open(routeData.href, "_blank");
      }
    },
    closeMenu() {
      this.isCollapse = false;
    },
  },
  async mounted() {
    let years = localStorage.getItem("homeYearIndex");
    if (years && !isNaN(years)) {
      this.year = Number(years);
    } else {
      localStorage.setItem("homePageYearVal", this.year);
    }
    localStorage.setItem("homeYearIndex", this.year);
    if (this.$route.params.reload == 11) {
      window.location.reload();
      this.$router.push({
        name: "home",
      });
    }
    // await this.getUserCompany();
    // 路由拦截，公司id 为-1，跳转到创建渔场页面
    if (this.loginUser) {
      let hasEnterPrise = await this.getCurCompany();
      // TODO: 数组里的公司显示 尾水监测，其余的显示水质监测
      let companyIdArr = [3363802];
      if (companyIdArr.includes(hasEnterPrise.id)) {
        this.leftList = this.specialLeftList;
        // this.leftList[1].child.splice(2, 1)
      } else if (hasEnterPrise.id == "636089367965017082") {
        // 1804198
        // 水质监测/尾水监测 两个都显示的公司
      } else {
        this.leftList[1].child.splice(3, 1);
      }
      //华南农大权限判断
      let hnndCompanyIds = [2082303, 3868765];//测试环境：2082303,正式环境：3868765
      if (!hnndCompanyIds.includes(hasEnterPrise.id)) {
        this.leftList[0].child = this.leftList[0].child.filter(c => c.name !== "种植品种设置");
      }
      this.isOwner = hasEnterPrise.isOwner;
      if (hasEnterPrise.id == -1) {
        // this.$router.push({
        //   name: "CreateFishery"
        // });
        this.$router.push({
          name: "changeFishery",
        });
      }
    }
    await this.getCompanys();

    let oldCompany = this.enterprises.find((f) => f.selected == true);
    this.companyName = oldCompany.enterpriseId;
    this.leftside();
  },
  computed: {
    ...mapState(["loginUser", "inQlw", "curCompany"]),
    ...mapState(modules.account, ["enterprises"]),

    getRoute() {
      return this.$route.path;
    },
    // 获取 是否为企联网
    whetherQlw() {
      return this.curCompany.isQlwVersion;
    },
    // 无 permissions 时是否只渲染内容区（隐藏侧栏/顶栏）
    showBareLayout() {
      if (!this.loginUser || this.loginUser.permissions != null) {
        return false;
      }
      // 企联网版本：仅嵌入企联网入口时隐藏菜单；直连访问需显示完整布局
      if (this.curCompany.isQlwVersion === true) {
        return this.inQlw;
      }
      // 公司信息尚未加载，暂不切无菜单布局，避免企联网直连误判
      if (this.curCompany.isQlwVersion == null) {
        return false;
      }
      // 非企联网版本且无 permissions
      return true;
    },
    isYinbaoEnterprise() {
      const logoFlag = this.curCompany && this.curCompany.logoFlag;
      return isYinbaoLogoByFlag(logoFlag);
    },
    logoImg() {
      return this.isYinbaoEnterprise ? YINBAO_LOGO : "/img/logo.png";
    },
    logoSmallImg() {
      return this.isYinbaoEnterprise ? YINBAO_LOGO : "/img/logo_small.png";
    },
    //判断第一层子元素的显示隐藏(需判断第二级与第三级有无元素为true)
    level1(val) {
      return function (val) {
        let isTure = val.child.every((item) => {
          // 判断第三层级是否有元素为true
          if (item.child && item.child.length != 0) {
            let result = item.child.every((m) => {
              return item.show == false;
            });
            if (result) {
              return true;
            } else {
              return false;
            }
          } else {
            return item.show == false;
          }
        });
        if (isTure) {
          return false;
        } else {
          return true;
        }
      };
    },
    //判断第二层子元素的显示隐藏
    level2(val) {
      return function (val) {
        let isTure = val.child.every((item) => {
          return item.show == false;
        });

        if (isTure) {
          return false;
        } else {
          return true;
        }
      };
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="stylus">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 220px;
}
body >, .el-container {
  margin-bottom: 40px;
}

.home {
  height: 100%;

  .el-main {
    padding: 10px;
  }

  .home-container {
    height: 100%;

    .leftMain {
      width: 210px !important;

      &.isActive {
        width: 64px !important;
      }

      // 左侧侧边栏
      .left1 {
        // height:10%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 210px !important;
        border-right: 1px solid #e0e0e0;
        // box-shadow 5px 5px 10px #e7e6e6
        background-color: #fff;

        &.isActive {
          width: 64px !important;
        }

        .left-logo {
          height: 82px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          border-bottom: 1px solid #DDDDDD;

          img {
            cursor: pointer;

            &.yinbao-logo-img {
              max-width: 100%;
              max-height: 72px;
              width: auto;
              height: auto;
              object-fit: contain;
            }
          }
        }
      }

      .left {
        margin-top: 83px;
        height: 91%;
        width: 210px !important;
        border-right: 1px solid #e0e0e0;
        background-color: #fff;
        // 2020 3 19
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 210px !important;
        border-right: 1px solid #e0e0e0;
        background-color: #fff;

        &.isActive {
          width: 64px !important;
        }

        .el-menu-vertical-demo {
          border-right: none;

          .el-submenu .el-menu-item {
            // padding-left:80px!important;
            color: #565656;
            font-size: 15px;
            height: 54px !important;
            line-height: 54px !important;
          }

          .el-menu-item, .el-submenu__title {
            color: #333;
            font-size: 16px;
            height: 60px !important;
            line-height: 60px !important;
          }

          .el-menu-item.is-active {
            color: #565656;
            background: #c3e3ff;
          }
        }

        &.isActive {
          .el-submenu__title {
            span {
              margin-left: 20px;
            }
          }

          .el-submenu__icon-arrow {
            position: absolute;
            top: 50%;
            right: -9px;
          }
        }
      }
    }

    .main-header {
      display: flex;
      align-items: center;
      height: 54px !important;
      line-height: 54px !important;
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid #ddd;

      .main-header-logo {
        flex: 1;
        display: flex;
        justify-content: space-between;

        .main-header-logo-one, .main-header-logo-two {
          >img {
            cursor: pointer;
          }
        }

        .main-header-logo-two {
          >img {
            margin-right: 3vh;
          }
        }

        .main-header-1 {
          display: flex;
        }
      }

      .yearChange {
        margin-left: 26px;

        .el-select .el-input__inner {
          width: 100px;
          color: #666;
        }

        .el-select>.el-input {
          display: block;
          width: 100px;
        }
      }

      .main-header-box {
        display: flex;
        align-items: center;
        // .el-input--small .el-input__inner
        // width 190px
        // border 0
        // color #3389ff
        // .el-icon-arrow-up:before
        // content "\E605"
        // color #3389ff
      }

      .main-header-box-one {
        display: flex;
        border: 1px solid rgba(221, 221, 221, 1);
        border-bottom: none;
        border-top: none;
        margin-right: 40px;

        >li {
          width: 90px;
          text-align: center;
          cursor: pointer;
        }

        .li img {
          display: none;
          position: absolute;
          top: 80px;
          right: 0px;
          width: 100px;
          height: 100px;
        }

        .li:hover img {
          display: block;
          position: absolute;
          z-index: 2;
          top: 60px;
          right: 310px;
          width: 100px;
          height: 100px;
        }
      }

      .main-header-box-two {
        margin: 0 10px 0 -10px;

        >img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          vertical-align: middle;
          cursor: pointer;
          margin-top: -2px;
          border-radius: 25px;
        }

        .el-dropdown-link {
          color: #3389ff;
          margin-right: 10px;
        }
      }

      // 切换公司样式
      .selectCompany {
        .el-input {
          text-align: center;
          margin-left: -8px !important;
          width: 180px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .selectCompany .el-input__inner {
        width: 180px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        border: none;
        // padding-right: 45px;
        color: #3389ff;
      }

      .selectCompany .el-icon-arrow-up:before {
        color: #3389ff;
      }

      .selectCompany {
        .el-select-dropdown_item {
          .selected {
            color: #3389ff;
          }
        }
      }
    }

    // 主体容器
    .main {
      background: #F2F3F6;
      color: #3333;
    }

    // 主体底部
    .footer {
      color: #333;
      text-align: center;
      line-height: 60px;
    }
  }
}
</style>
